import dayjs from 'dayjs';
import 'dayjs/locale/et';
import 'dayjs/locale/lt';
import 'dayjs/locale/lv';
import 'dayjs/locale/ru';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import duration from 'dayjs/plugin/duration';

dayjs.extend(advancedFormat);
dayjs.extend(isBetween);
dayjs.extend(duration);
